export default "__VITE_ASSET__8_eO$QKb__";